<template>
    <div :contenteditable="edits"
         v-html="innerText"
         @input="changeText"
         class="td"
         ></div>
</template>
<script>
    export default {
        name:"TableInput",
        props: ['value','edit'],
        data(){
            return {
                innerText:this.value,
                edits:this.edit
                }
        },
        methods:{
            changeText(){
                this.innerText = this.$el.innerHTML;
                this.$emit('input',this.innerText);
            }
        }
    }
</script>


<style scoped>
.td{
 width:2rem;   
 word-wrap: break-word;
 word-break: break-all;
 border: none;
 outline: none;
}
</style>




// WEBPACK FOOTER //
// src/globalComponent/Table/TableInput.vue